import styled from 'styled-components';
import { XIColorUsage } from '@inmoment/the-kitchen';

export const Page = styled.div`
  padding: 60px 66px;
  background: ${XIColorUsage.silver};
  flex: 1;
  position: relative;
  box-sizing: border-box;
  height: fit-content;
  width: 100%;
`;

export const TextContainer = styled.div`
  max-width: 900px;
  @media (max-width: 1180px) {
    max-width: 100%;
  }
`;
